export const isEnvForcedMaintenanceMode = () => {
    const raw = process.env.MIX_FORCE_MAINTENANCE_MODE
    if (raw == null || raw === '') {
        return false
    }
    return (
        String(raw)
            .toLowerCase()
            .trim() === 'true'
    )
}
